<div id="pal-balance-list" data-testid="pal-balance-list">
  <mm-pal-balance 
    *ngFor="let balance of balances; let i = index" 
    [class.first-pal-balance]="i === 0"
    [balance]="balance"
    data-testid="balance.type">
  </mm-pal-balance>
</div>
